import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const securityApi = createApi({
  reducerPath: 'securityApi',
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_SECURITY}`,
  }),
  tagTypes: ['Security'],
  keepUnusedDataFor: 30,
  endpoints: (builder) => ({
    generateToken: builder.mutation({
      query: (token) => ({
        url: 'checkout-security/api/v1/security',
        method: 'POST',
        body: new URLSearchParams({
          'g-recaptcha-response': token,
        }),
      }),
    }),
  }),
});

export const { useGenerateTokenMutation } = securityApi;
